import ErrorMessage from "@components/ErrorMessage"
import { TitleValueList } from "@components/TitleValueList/TitleValueList"
import type { TTitleValueItem } from "@components/TitleValueList/types"
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from "@components/ui/card"
import { cn } from "@components/ui/lib/utils"
import { defaultApiErrorMessage } from "@utils/textDefaults"
import { type ReactNode, Children, isValidElement } from "react"

const ActionSlot = ({ children }: { children: ReactNode }) => children
const TitleSlot = ({ children }: { children: ReactNode }) => children

type TAccountStatusProps = {
  sectionTitle?: string
  items: TTitleValueItem[]
  isError?: boolean
  children?: ReactNode
  className?: {
    card?: string
    header?: string
    title?: string
    action?: string
    content?: string
  }
}

export const CardDataList = ({
  sectionTitle,
  items,
  isError = false,
  children,
  className,
}: TAccountStatusProps) => {
  const childrenArray = Children.toArray(children)
  const actionSlot = childrenArray.find(
    (child) => isValidElement(child) && child.type === ActionSlot,
  )
  const titleSlot = childrenArray.find(
    (child) => isValidElement(child) && child.type === TitleSlot,
  )
  return (
    <Card className={cn(className?.card)}>
      {(sectionTitle || titleSlot || actionSlot) && (
        <CardHeader className={cn(className?.header)}>
          <CardTitle
            className={cn("tw:text-lg tw:font-bold", className?.title)}
          >
            {sectionTitle ?? titleSlot}
          </CardTitle>
          {actionSlot && (
            <CardAction className={cn(className?.action)}>
              {actionSlot}
            </CardAction>
          )}
        </CardHeader>
      )}
      <CardContent className={cn(className?.content)}>
        {isError ? (
          <ErrorMessage message={defaultApiErrorMessage} />
        ) : (
          <TitleValueList
            items={items}
            variant="custom"
            variantClasses={{
              layout: "tw:flex tw:flex-wrap tw:gap-y-1",
              wrapper:
                "tw:flex tw:basis-1/2 tw:md:basis-full tw:gap-1 tw:flex-wrap",
              title: "tw:font-bold",
            }}
          />
        )}
      </CardContent>
    </Card>
  )
}

CardDataList.Action = ActionSlot
CardDataList.Title = TitleSlot
